import React from "react";
import Carousel from "react-material-ui-carousel";
import CustomerSubHeaderDetails from "./CustomerSubHeaderDetails";
import CustomerEmergency from "./CustomerEmergency";
import SubHeaderDetails from "components/subHeaderDetails/SubHeaderDetails";
import { Grid, Paper, IconButton } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

function CustomerCarousel(props) {
  const emergencyContactsLength = props?.details?.EmergencyContacts?.length > 3;

  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="space-around"
      alignItems="flex-start"
      className="customerCarousel"
      sm={12}
      md={3.3}
    >
      <Grid sm={12} className="width100">
        {emergencyContactsLength ? (
          <Carousel
            swipe={false}
            navButtonsWrapperProps={{
              style: {
                top: "50%",
                transform: 'translateY(-50%)',
                height: "auto",
                zIndex: 2,
              },
            }}
            NavButton={({ onClick, className, style, next, prev }) => {
              return (
                <IconButton
                  onClick={onClick}
                  className={className}
                  style={{
                    ...style,
                    pointerEvents: "auto",
                    background: "transparent",
                    zIndex: 5,
                  }}
                  size="small"
                >
                  {next ? (
                    <ArrowForwardIos fontSize="small" />
                  ) : (
                    <ArrowBackIos fontSize="small" />
                  )}
                </IconButton>
              );
            }}
          >
            {props?.type === "Driver" ? (
              <Paper>
                <SubHeaderDetails
                  details={props?.details}
                  loader={props?.loader}
                  type={props?.type}
                  editIconFalse={props?.editButton}
                  editData={props?.editData}
                  onSubmittBtn={props?.onSubmittBtn}
                  onDelete={props?.onDelete}
                />
              </Paper>
            ) : (
              <Paper className="border_box_shadow">
                <CustomerSubHeaderDetails
                  details={props?.details}
                  loader={props?.loader}
                />
              </Paper>
            )}
            <Paper className="border_box_shadow">
              <CustomerEmergency details={props?.details} first3={true} />
            </Paper>
            <Paper className="border_box_shadow">
              <CustomerEmergency details={props?.details} last2={true} />
            </Paper>
          </Carousel>
        ) : props?.details?.EmergencyContacts?.length > 0 ||
          props?.details?.DriverProfile?.EmergencyContacts?.length > 0 ? (
          <Carousel
            navButtonsAlwaysInvisible={false}
              navButtonsWrapperProps={{
              style: {
                top: "50%",
                transform: 'translateY(-50%)',
                height: "auto",
                zIndex: 2,
              },
            }}
            NavButton={({ onClick, className, style, next, prev }) => {
              return (
                <IconButton
                  onClick={onClick}
                  className={className}
                  style={{
                    ...style,
                    pointerEvents: "auto",
                    background: "transparent",
                    zIndex: 5,
                  }}
                  size="small"
                >
                  {next ? (
                    <ArrowForwardIos fontSize="small" />
                  ) : (
                    <ArrowBackIos fontSize="small" />
                  )}
                </IconButton>
              );
            }}
          >
            {props?.type === "Driver" ? (
              <Paper>
                <SubHeaderDetails
                  details={props?.details}
                  type={props?.type}
                  onSubmittBtn={props?.onSubmittBtn}
                  editData={props.editData}
                  loader={props?.loader}
                  editIconFalse={props?.editButton}
                  onDelete={props?.onDelete}
                />
              </Paper>
            ) : (
              <Paper>
                <CustomerSubHeaderDetails
                  details={props?.details}
                  loader={props?.loader}
                />
              </Paper>
            )}
            <Paper>
              <CustomerEmergency
                details={props?.details}
                first3={true}
                loader={props?.loader}
              />
            </Paper>
          </Carousel>
        ) : (
          <Paper>
            {props?.type === "Driver" ? (
              <SubHeaderDetails
                details={props?.details}
                type={props?.type}
                onSubmittBtn={props?.onSubmittBtn}
                editData={props.editData}
                loader={props?.loader}
                editIconFalse={props?.editButton}
                onDelete={props?.onDelete}
              />
            ) : (
              <CustomerSubHeaderDetails
                details={props?.details}
                loader={props?.loader}
              />
            )}
          </Paper>
        )}
      </Grid>
    </Grid>
  );
}

export default CustomerCarousel;
